import(/* webpackMode: "eager", webpackExports: ["ViewItemBeacon"] */ "/opt/buildhome/repo/components/analytics/ViewItemBeacon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotifyMe"] */ "/opt/buildhome/repo/components/NotifyMe.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CrossSellStrip"] */ "/opt/buildhome/repo/components/products/carousel/CrossSellStrip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetailAddToCart"] */ "/opt/buildhome/repo/components/products/detail/ProductDetailAddToCart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductGallery"] */ "/opt/buildhome/repo/components/products/detail/ProductGallery.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/products/detail/ProductReviewForm.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
